import isPortalSpecificObjectType from 'customer-data-objects/crmObject/isPortalSpecificObjectType';
import { getCustomObjectFallbackAppSettings } from './CustomObjectFallback';
export const getFallback = objectTypeId => {
  if (isPortalSpecificObjectType(objectTypeId)) {
    return getCustomObjectFallbackAppSettings();
  }
  return undefined;
};